module.exports = __webpack_public_path__ + "static/img/8dcd286632283558(1).19529178.png";